export const PostCallFormTestIds = {
  OUTCOME: 'post-call-form.outcome-select',
  OUTCOME_OPTION: 'post-call-form.outcome-option',
  NOTES: 'post-call-form.notes-input',
  SKIP: 'post-call-form.skip-button',
  SAVE: 'post-call-form.save-button',
};
